<template>
  <div class="alert" :class="[`alert-${variant}`]" role="alert">
    <slot>
      <h5 class="alert-heading d-flex align-items-center fs-6">
        <slot name="heading"></slot>
      </h5>
      <slot name="content"></slot>
    </slot>

    <button
      v-if="dismissible"
      type="button"
      class="btn-close"
      data-dismiss="alert"
      aria-label="Close"
      @click="$emit('dismiss')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script lang="ts">
export type AlertVariant =
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "light"
  | "dark";

export type UIAlertProps = {
  content?: string;
  dismissible?: boolean;
  heading?: string;
  variant?: AlertVariant;
};

export type UIAlertEvents = {
  (event: "dismiss"): unknown;
};
</script>

<script lang="ts" setup>
withDefaults(defineProps<UIAlertProps>(), {
  variant: "info",
});
defineEmits<UIAlertEvents>();
</script>
